export default __webpack_public_path__ + "static/game_rules-16a1c8b9576798cb6dd210344e9c8913.mp3";